import { fromJS } from "immutable";

import types from "./types";

export const initialState = fromJS({});

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case types.SET_PARENT_CAMPAIGN: {
      return state.merge(action.campaign);
    }

    default: {
      return state;
    }
  }
};
